module.exports = __webpack_public_path__ + "ki.svg?db9ce4a8eedd3429844cb999147e4e05";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-flag-icon/node_modules/flag-icon-css/flags/4x3/ki.svg
// module id = 1444
// module chunks = 0